/*! Copyright 2025 Lane Crawford, All Rights Reserved. */


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * events
	 * store/beauty events and offers module
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "events", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {



		};

		/**
		 * init() is executed when DOM is ready.
		 */
		ex.init = function() {

			_this.$btn = $("#btnSubscribe");

		};

		/**
		 * events() is executed last, after the
		 * DOM is ready to receive event bindings.
		 */
		ex.events = function() {

			_this.$btn
				.off( "click" )
				.on( "click", function() {

					LC.newsletter.subscribe.showForm( true );

					LC.track.trigger( "ga.event", {
						category: "Subscribe Newsletter Form",
						action: "Click",
						label: "From Events Page"
					});

				});

		};

		/**
		 * subscribe() is executed after setup() and
		 * before the DOM is ready.
		 */
		ex.subscribe = function() {



		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=events.js
